import React from 'react';
import styles from './cookie-banner.module.scss';
import useConsent from '../../hooks/useConsent';

type Props = {
  className?: string;
};

const CookieBanner: React.FC<Props> = ({ className }) => {
  const { consent, updateCategories, openPrefs } = useConsent();

  if (consent.given) return null;

  const acceptAll = () => {
    updateCategories({ analytics: true, necessary: true }, true);
  };
  const managePreferences = () => {
    openPrefs();
  };

  const rootClass = [styles['cookie-banner'], className]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className={rootClass} role="dialog" aria-live="polite">
        <p className={styles['cookie-banner__text']}>
          We use cookies to improve your experience and understand site usage.
          Please choose your preferences to continue.
        </p>

        <div className={styles['cookie-banner__actions']}>
          <button className={styles['cookie-banner__btn']} onClick={acceptAll}>
            Accept all
          </button>

          <button
            className={styles['cookie-banner__link']}
            onClick={managePreferences}
          >
            Manage preferences
          </button>
        </div>
      </div>
      <div className={styles['cookie-banner__backdrop']}></div>
    </>
  );
};

export default CookieBanner;
